import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { OfbizField, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ubs-edit-blog-image',
  templateUrl: './edit-blog-image.component.html',
  styleUrls: ['./edit-blog-image.component.scss']
})
export class EditBlogImageComponent implements OnInit {
  @Input() imageUrl:string;
  @Input() formGroupName: string;
  @Input() ofbizForm:OfbizForm;
  @Input() fields:OfbizField[];
  initialState = "view";
  form: FormGroup;
  uploadImageSrc:any;
  imageLoaded = false;

  @Output() imageSubmit = new EventEmitter<string>();

  constructor(private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }

  uploadFile(event){
    console.log("It changed");
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.createPreview(file);
      file = new File([file], file.name);
      this.form.get('uploadedFile').setValue(file);      
    }
  }

  createPreview(file){
    const reader = new FileReader();
    //reader.onload = e => this.uploadImageSrc = reader.result;
    reader.addEventListener("load",() => {
      this.uploadImageSrc = reader.result;
    })
    if(file){
      reader.readAsDataURL(file);
    }
    this.imageLoaded = true;
  }

  submit(){
    this.imageSubmit.emit(this.form.value);
  }

}
